import Vue from 'vue'
import Router from 'vue-router'
import AboutUs from '../components/About-Us.vue'
import CreateUserForm from '../components/Create-User-Form.vue'
import MonumentDetailedView from '../components/Monument-Detailed-View'
import MonumentUploadForm from '../components/Monument-Upload-Form.vue'
import SignIn from '../components/Sign-In.vue'
import SignOut from '../components/Sign-Out.vue'
import UpdateProfileForm from '../components/Update-Profile-Form.vue'
import TIUserList from '../components/TI-User-List.vue'
import HomePage from '../components/Home-Page.vue'
import SouvenirListView from '../components/Souvenir-List-View.vue'
import SouvenirCreateUpdateView from '../components/Souvenir-Create-Update-Form.vue'
import CompaniesListView from '../components/Partner-Companies-List-View.vue'
import CompaniestUploadForm from '../components/Partner-Companies-Upload-Form.vue'
import WalkUploadForm from '../components/Walk-Upload-Form.vue'
import WalkListView from '../components/Walk-List-View.vue'

Vue.use(Router)

const router = new Router({
  routes: [
    { path: '/', component: HomePage },
    { path: '/users/list', component: TIUserList },
    { path: '/users/create', component: CreateUserForm },
    { path: '/monuments/list', component: HomePage },
    { path: '/monuments/create', component: MonumentUploadForm },
    { path: '/monuments/:id', component: MonumentDetailedView, props: true },
    { path: '/profile', component: UpdateProfileForm },
    { path: '/signin', component: SignIn },
    { path: '/signout', component: SignOut },
    { path: '/about', component: AboutUs },
    { path: '/souvenirs/list', component: SouvenirListView },
    { path: '/souvenirs/create', component: SouvenirCreateUpdateView },
    { path: '/companies/list', component: CompaniesListView },
    { path: '/companies/create', component: CompaniestUploadForm },
    { path: '/souvenirs/create', component: SouvenirCreateUpdateView },
    { path: '/walks/create', component: WalkUploadForm },
    { path: '/walks/list', component: WalkListView }
  ]
})

router.beforeEach((to, from, next) => {
  if (router.match(to).matched.length === 0) {
    next('/')
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js